import { handleActions } from 'redux-actions'

import { updateUser } from './actions'
import { Role } from '../../../types/index'

export const INITIAL_STATE = {
  user: {},
  role: Role.UNAUTHENTICATED,
  menu: [],
}

export default handleActions(
  {
    [updateUser]: (state, { payload: { user, role, menu } }) => ({
      ...state,
      user,
      role,
      menu,
    }),
  },
  INITIAL_STATE,
)
